import React, { memo, useCallback } from 'react';
import styles from './Tag.module.less';
import ZT from '../../../static/comment_zt.svg';
import { CONTEXT } from '../../../config';
import Toast from '../../Toast/Toast';
import { useHistory } from 'react-router-dom';
import SOFT from '../../../static/comment_soft.svg';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { logPostInfo } from '../../../actions/log';
import { useAliveController } from 'react-activation';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
/**
 * type: zt:专题，soft:软件
 */
export default memo(({ data, type }) => {
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const dispatch = useDispatch();
  const { dropScope } = useAliveController();

  const handelClick = useCallback(() => {
    if (type === 'soft') {
      if (data?.softId) {
        dispatch(
          logPostInfo({
            source_p: logInfoData.source + `||comment`,
            source_pp: logInfoData.source_p,
          }),
        );
        history.push(`${CONTEXT}/detail/soft/${data?.softId}/${data?.bizInfo || '{}'}`);
      } else {
        Toast.error({ content: '该软件尚未上架…' });
      }
    } else {
      dispatch(
        logPostInfo({
          source_p: logInfoData.source + `||comment`,
          source_pp: logInfoData.source_p,
        }),
      );
      if (history?.pathname?.indexOf(`${CONTEXT}/special`) < 0) {
        dropScope('special');
      }
      const timer = setTimeout(() => {
        history.push(`${CONTEXT}/special?ztId=${data?.ztId}&bizInfo=${data?.bizInfo}`);
        clearTimeout(timer);
      }, 50);
    }
  }, [data, logInfoData]);

  const filterDom = useCallback(str => {
    if (str) {
      return str.replace(/</g, '').replace(/>/g, '');
    }
    return '';
  }, []);
  return (
    <div className={styles.tag} onClick={handelClick}>
      <img src={type === 'zt' ? ZT : data?.logoFile || SOFT} />
      {type === 'zt' && (
        <div
          className={styles.tag_zt}
          dangerouslySetInnerHTML={{ __html: filterDom(data?.name) }}
        />
      )}

      {type === 'soft' && (
        <div
          className={styles.tag_soft}
          dangerouslySetInnerHTML={{ __html: filterDom(data?.name) }}
        />
      )}
    </div>
  );
});
